.gallery {
  width: 100%;
}

.previewContainer {
  display: flex;
  justify-content: start;
  gap: 0.5em;
  margin-top: 0.5em;
}

.previewImage {
  flex: 1;
  min-width: 0;
  height: 85px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.previewImage:hover {
  opacity: 1;
}

.activePreview {
  opacity: 1;
  border: 2px solid var(--mantine-primary-color-9);
}

.moreImages {
  flex: 1;
  min-width: 0;
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--mantine-primary-color-1);
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  color: var(--mantine-primary-color-9);
}

.mainImage {
  width: 100%;
  height: 300px;
}

.mantineModalTitle {
  font-size: 1.25em;
}
